/*
 * Two-finger trackpad swipes arrive as horizontal wheel events. Swiper ignores
 * them unless its mousewheel module is on, Yotpo's Glide reviews carousel has
 * no wheel support, and the desktop product gallery (thumbnail layout) shows
 * one image at a time, so these only moved by arrows, thumbnails or drag.
 * Scrolling rows (overflow-x) already follow the trackpad and are left alone.
 *
 * Each carousel is wired the first time a horizontal swipe reaches it, which
 * also covers ones initialised late. The listener added here still receives
 * the current event, because the event has not reached the carousel yet.
 */
(() => {
  // One step per swipe, for carousels that move by buttons.
  const wireSteps = (el, step, active) => {
    let travelled = 0;
    let stepped = false;
    let idle;
    el.addEventListener('wheel', (event) => {
      if (!active()) return;
      // macOS keeps sending momentum deltas after the fingers lift: one flick
      // moves one slide, the next step waits until the wheel goes quiet. Any
      // wheel event counts, so a swipe that drifts vertically stays one step.
      clearTimeout(idle);
      idle = setTimeout(() => { travelled = 0; stepped = false; }, 150);
      if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
      event.preventDefault();
      if (stepped) return;
      travelled += event.deltaX;
      if (Math.abs(travelled) < 50) return;
      stepped = true;
      step(travelled > 0 ? 1 : -1);
      travelled = 0;
    }, { passive: false });
  };

  const stepGlide = (glide) => (direction) => {
    const arrow = glide.querySelector(direction > 0 ? '.glide__arrow--right' : '.glide__arrow--left');
    if (arrow) arrow.click();
  };

  const stepGallery = (gallery) => (direction) => {
    const buttons = [...gallery.elements.thumbnails.querySelectorAll('[data-target] button')];
    const current = buttons.findIndex((button) => button.hasAttribute('aria-current'));
    const next = buttons[current + direction];
    if (next) next.click();
  };

  document.addEventListener('wheel', (event) => {
    if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
    // Only the innermost carousel under the pointer, so nested ones never move together.
    for (let el = event.target; el && el.nodeType === 1; el = el.parentElement) {
      const swiper = el.swiper;
      const isSwiper = swiper && swiper.mousewheel && swiper.isHorizontal();
      const isGlide = el.classList.contains('glide');
      const isGallery = el.tagName === 'MEDIA-GALLERY' && el.elements && el.elements.thumbnails;
      if (!isSwiper && !isGlide && !isGallery) continue;
      if (isSwiper) {
        // Checked on the instance, not flagged on the element, so a Swiper
        // re-created on the same element (section reload) is wired again.
        if (!swiper.mousewheel.enabled) {
          // forceToAxis: only sideways swipes move it, vertical ones still scroll the page.
          Object.assign(swiper.params.mousewheel, { enabled: true, forceToAxis: true });
          swiper.mousewheel.enable();
        }
        return;
      }
      if (el.dataset.trackpadReady) return;
      el.dataset.trackpadReady = '1';
      if (isGlide) {
        wireSteps(el, stepGlide(el), () => true);
      } else {
        // Below 750px the gallery is a scrolling row, which needs nothing.
        wireSteps(el, stepGallery(el), () => el.mql.matches);
      }
      return;
    }
  }, { capture: true, passive: true });
})();
